import type { SVGProps } from 'react';

export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}>
      <path
        d="M11.2364 2.26556C11.5879 2.61703 11.5879 3.18688 11.2364 3.53835L6.77321 8.00152L11.2345 12.4629C11.586 12.8144 11.586 13.3842 11.2345 13.7357C10.883 14.0872 10.3132 14.0871 9.96169 13.7357L4.93474 8.70861C4.54422 8.31808 4.54422 7.68492 4.93474 7.2944L9.9636 2.26556C10.3151 1.91408 10.8849 1.91409 11.2364 2.26556Z"
        fill="#currentColor"
      />
    </svg>
  );
};
